var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-notification',{staticClass:"bg-emerald-50 border-emerald-300 text-emerald-900",attrs:{"message":_vm.message}})
}
var staticRenderFns = []

export { render, staticRenderFns }